import { useParams } from 'react-router-dom';
import { PublicationStatusRedirect } from 'src/components/PublicationStatusRedirect/PublicationStatusRedirect';
import { useTimetable } from 'src/hooks/useTimetable';
import { Routes } from 'src/routes';

export const TimetablePublicationStatus = () => {
  const { timetableId } = useParams<{ timetableId: string }>();

  if (!timetableId) {
    throw new Error('TimetablePublicationStatus rendered without a timetableId route param');
  }

  const { data, isLoading } = useTimetable(timetableId);
  const timetable = data?.data;

  return (
    <PublicationStatusRedirect
      isLoading={isLoading}
      name={timetable?.name}
      eventId={timetable?.publication?.event_id}
      listLabel="Timetables"
      listPath={Routes.TIMETABLES}
      notPublishedMessage="This timetable has not been published"
    />
  );
};
